<template lang="pug">
v-layout.my-6
  v-row.fill-height.ma-0(align='center' justify='center')
    v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
</template>

<script>
export default {
  data: () => ({}),
  mounted () {
    this.$router.push('/signin')
  }
}
</script>

<style scoped></style>
